// extracted by mini-css-extract-plugin
export default {"container":"OpeningUnavailable_container__lvdsT","header":"OpeningUnavailable_header__iAFzW","content":"OpeningUnavailable_content__sFewC"};